/* eslint-disable no-plusplus */
/* eslint-disable one-var-declaration-per-line */
const calcularPascoa = (ano: number) => {
  const G = ano % 19
  const C = Math.floor(ano / 100)
  const H = (C - Math.floor(C / 4) - Math.floor((8 * C + 13) / 25) + 19 * G + 15) % 30
  const I = H - Math.floor(H / 28) * (1 - Math.floor(29 / (H + 1)) * Math.floor((21 - G) / 11))
  const J = (ano + Math.floor(ano / 4) + I + 2 - C + Math.floor(C / 4)) % 7
  const L = I - J; const M = 3 + Math.floor((L + 40) / 44)
  const D = L + 28 - 31 * Math.floor(M / 4)
  return new Date(ano, M - 1, D)
}

const adicionarDiasUteisComFeriados = (diasUteis: number, dataInicial: Date = new Date()) => {
  const data = dataInicial
  let adicionados = 0

  const ano = data.getFullYear()

  const pascoa = calcularPascoa(ano)
  const carnaval = new Date(pascoa)
  carnaval.setDate(pascoa.getDate() - 47)
  const sextaSanta = new Date(pascoa)
  sextaSanta.setDate(pascoa.getDate() - 2)
  const corpusChristi = new Date(pascoa)
  corpusChristi.setDate(pascoa.getDate() + 60)

  const feriados: Array<Date> = [
    new Date(ano, 0, 1), // 1º de janeiro - Confraternização Universal
    new Date(ano, 3, 21), // 21 de abril - Tiradentes
    new Date(ano, 4, 1), // 1º de maio - Trabalho
    new Date(ano, 8, 7), // 7 de setembro - Independência
    new Date(ano, 9, 12), // 12 de outubro - N. Sra. Aparecida
    new Date(ano, 10, 2), // 2 de novembro - Finados
    new Date(ano, 10, 15), // 15 de novembro - Proclamação da República
    new Date(ano, 11, 25), // 25 de dezembro - Natal
    carnaval,
    sextaSanta,
    corpusChristi,
  ]

  function ehFeriado(d: Date) {
    return feriados.some(f => f.getDate() === d.getDate()
      && f.getMonth() === d.getMonth())
  }

  while (adicionados < diasUteis) {
    data.setDate(data.getDate() + 1)
    const diaSemana = data.getDay()
    if (diaSemana !== 0 && diaSemana !== 6 && !ehFeriado(data)) {
      adicionados++
    }
  }

  return data
}

const adicionarDiasUteisSemFeriados = (diasUteis: number, dataInicial: Date = new Date()) => {
  const data = dataInicial
  let adicionados = 0

  while (adicionados < diasUteis) {
    data.setDate(data.getDate() + 1)
    const diaSemana = data.getDay()
    // 0 = Domingo, 6 = Sábado → não conta como útil
    if (diaSemana !== 0 && diaSemana !== 6) {
      adicionados++
    }
  }

  return data
}

export {
  adicionarDiasUteisSemFeriados, adicionarDiasUteisComFeriados,
}
